import React from "react";
import { Router } from "@reach/router";
import { ReactQueryDevtools } from "react-query/devtools";

import Layout from "../components/layout/Layout";
import PublicRoute from "../components/PublicRoute";
import PrivateRoute from "../components/PrivateRoute";
import Login from "../components/screens/login";
import Home from "../components/screens/home";
import Seo from "../components/seo";
import Sonicboxes from "../components/screens/sonicboxes";
import { apiQueryClient } from "../hooks/useApi";
import {
  PROFILE_SECTION_CREDITS,
  PROFILE_SECTION_FAVORITES,
  PROFILE_SECTION_MENU,
  PROFILE_SECTION_ORDERS,
  PROFILE_SECTION_PROFILE,
  PROFILE_SECTION_SCANNER,
} from "../constants";
import Menu from "../components/screens/account/Menu";
import Orders from "../components/screens/account/Orders";
import Profile from "../components/screens/account/Profile";
import Credits from "../components/screens/account/Credits";
import Scanner from "../components/screens/account/Scanner";
import Favorites from "../components/screens/account/Favorites";
import versionUpdater from "../services/versionUpdater";
import { LanguageProvider } from "../hooks/useLanguage";
import Privacy from "../components/screens/privacy";
import EmailVerification from "../components/screens/emailverification";
import EmailLogin from "../components/screens/EmailLogin";
import OnlyPublicRoute from "../components/OnlyPublicRoute";
import NotFound from "../components/screens/NotFound";
import EntryFlowRoute from "../features/entryFlow/EntryFlowRoute";

import RadioEntryGuard from "../features/entryFlow/RadioEntryGuard";

versionUpdater();

const App = () => (
  <LanguageProvider>
    <Layout>
      <Seo description="Sonicbox - " lang="es" meta={[]} title="Sonicbox" />
      <RadioEntryGuard>
        <Router>
          <PublicRoute path="/" component={Home} />
          <OnlyPublicRoute path="/login" component={Login} />
          <OnlyPublicRoute path="/verify" component={EmailVerification} />
          <EntryFlowRoute path="/redeem/:code" source="redeem" />
          <EntryFlowRoute path="/task/:nameseo" source="task" />
          <PrivateRoute path="/sonicboxes" component={Sonicboxes} />
          <EntryFlowRoute path="/sonicbox/:nameseo" source="sonicbox" />
          <PrivateRoute path={`/${PROFILE_SECTION_MENU}`} component={Menu} />
          <PrivateRoute
            path={`/${PROFILE_SECTION_FAVORITES}`}
            component={Favorites}
          />
          <PrivateRoute
            path={`/${PROFILE_SECTION_ORDERS}`}
            component={Orders}
          />
          <PrivateRoute
            path={`/${PROFILE_SECTION_CREDITS}`}
            component={Credits}
          />
          <PrivateRoute
            path={`/${PROFILE_SECTION_SCANNER}`}
            component={Scanner}
          />
          <PrivateRoute
            path={`/${PROFILE_SECTION_PROFILE}`}
            component={Profile}
          />
          <PublicRoute path="/privacy" component={Privacy} />
          <OnlyPublicRoute path="/loginemail" component={EmailLogin} />
          <NotFound default />
        </Router>
      </RadioEntryGuard>
      {process.env.NODE_ENV !== "production" ? (
        <ReactQueryDevtools client={apiQueryClient} initialIsOpen={false} />
      ) : null}
    </Layout>
  </LanguageProvider>
);

export default App;
